
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M19.33 28.25V38.5M12.85 38.5h12.96M10.13 23.76A11.66 11.66 0 0031 16.6V15M28.93 5.29H7.67V16.6"}}),_c('path',{attrs:{"d":"M7.71 27.09a11.54 11.54 0 00-2.24-3.18 11.43 11.43 0 00-3.18-2.24 11.28 11.28 0 003.18-2.24 11.43 11.43 0 002.24-3.18A11.4 11.4 0 0010 19.44a11.26 11.26 0 003.18 2.23 11.66 11.66 0 00-3.19 2.24 11.52 11.52 0 00-2.28 3.18zM31 15.86a13.9 13.9 0 00-6.68-6.68 14.25 14.25 0 003.93-2.76A14.12 14.12 0 0031 2.5a14.25 14.25 0 002.76 3.93 14.12 14.12 0 003.92 2.75A13.9 13.9 0 0031 15.86z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    